import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { apiPutVoid } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

// Приватность встречи. Право — у круга встречи (проверяет бэк), поэтому UI не
// гейтит переключатель ролью.
export function useSetVisibility(meetingId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (isPrivate: boolean) =>
      apiPutVoid(`/meetings/${meetingId}/visibility`, { private: isPrivate }),
    onSuccess: (_data, isPrivate) => {
      toast.success(
        isPrivate ? 'Встреча скрыта — её видит только круг встречи' : 'Встреча снова видна всем',
      )
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
      void qc.invalidateQueries({ queryKey: meetingKeys.lists() })
    },
    onError: () => toast.error('Не удалось изменить видимость'),
  })
}
